import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { WatchOptions } from 'vue';
import InputText from '@/components/inputs/InputText/InputText.vue';
import InputCheckbox from '@/components/inputs/InputCheckbox/InputCheckbox.vue';
import InputRadioButton from '@/components/inputs/InputRadioButton/InputRadioButton.vue';
import { AnswerChoices, BreastSymptom } from '@/models/VariousEnum';
import { BreastSymptoms } from '@/models/QuestQuestion';

@Component({
  components: {
    InputText,
    InputCheckbox,
    InputRadioButton,
  },
})
export default class BreastSymptomsPart extends Vue {
  @Prop()
  public value!: BreastSymptoms;
  @Prop({ default: false })
  public readonly!: boolean;
  @Prop({ default: true })
  public required!: boolean;

  public answerChoices: any = AnswerChoices;
  public breastSymptom: any = BreastSymptom;
  public updating?: boolean = false;
  public errorMessage: string = '';
  public error: boolean = false;

  /**
   * Get an array of all the property names from the value prop in lowercase
   */
  get instanceFields(): string[] {
    if (this.value) {
      const fields: string[] = [];
      Object.keys(this.value).forEach(e => fields.push(e.toLowerCase()));
      return fields;
    }
    return [];
  }

  /**
   * Get the errors returned by the API corresponding to the model properties
   */
  get errors(): string[] {
    if (this.$store.state.questionnaireValidationErrors) {
      const obj = this.$store.state.questionnaireValidationErrors;
      const errorFields: string[] = [];
      Object.keys(obj).forEach((e) => {
        if (this.instanceFields.includes(e.toLowerCase())) {
          errorFields.push(obj[e].errors);
        }
      });
      return errorFields;
    }

    return [];
  }

  get showMoreQuestions(): boolean {
    return this.value.flagCurrentProblem === this.answerChoices.Yes;
  }

  get subQuestionRequired(): boolean {
    return this.value.flagCurrentProblem === this.answerChoices.Yes;
  }

  protected mounted() {
  }

  protected onBreastSymptomChange(value: boolean, symptom: BreastSymptom) {
    // TODO: compute the code based on checked boxes and emit the value to the parent
    switch (symptom) {
      case BreastSymptom.Pain:
        break;
      case BreastSymptom.Flow:
        break;
      case BreastSymptom.Boule:
        break;
      case BreastSymptom.Other:
      break;
      default:
        break;
    }
  }

  @Watch('value', { deep: true } as WatchOptions)
  protected onValueChanged(value: BreastSymptoms, oldValue: BreastSymptoms) {
    if (value) {
      this.$emit('input', value);
    }
  }
}
